import React from "react";
import { List, Avatar,ListItemAvatar, ListItem , ListItemText } from "@material-ui/core"
import {Button} from '@material-ui/core';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';

import './Todo.css';
import db from './firebase';

function Todo(props){
  return (
    <List className="todo__List">
      <ListItem>
        <ListItemAvatar>  
        </ListItemAvatar>
        <ListItemText primary={props.todo.todo} secondary="dummy deadline" />
      </ListItem>
      <DeleteForeverIcon onClick={event => db.collection('todos').doc(props.todo.id).delete()}> DELETE ME</DeleteForeverIcon>
    </List>
  );
};

export default Todo;
